import styled from 'styled-components'
import { IonProgressBar } from '@ionic/react'

export const StyledIonProgressBar = styled(IonProgressBar)`
  margin-top: 0.5em;
  margin-bottom: 0.25em;
`
